import { useMutation } from "react-query";
import useApi from "utils/api/useApi";
import { useSnackbar } from "notistack";

interface PostBody {
  file: File;
  name: string;
}

interface Body {
  body: PostBody;
  product_type_id: number;
}

export const useCreateProductTypeCarousel = () => {
  const api = useApi();
  const { enqueueSnackbar } = useSnackbar();
  const createProductTypeCarousel = async (body: Body) => {
    let formData = new FormData();
    formData.append("file", body.body.file);
    formData.append("name", body.body.name);
    const res = await api
      .path("item_class/carousel/create", {item_class_id: body.product_type_id})
      .multipost({body: formData});
    if (res?.data?.status === 0) {
      enqueueSnackbar("New item created!", {
        variant: "success",
      });
    } else {
      enqueueSnackbar(`Create new item faiiled! ${res?.data?.message}`, {
        variant: "error",
      });
    }
    return res?.data?.data
  };

  const { data, isLoading, error, mutate } = useMutation((body: Body) => createProductTypeCarousel(body));

  return {
    createProductTypeCarouselData: data,
    createProductTypeCarouselError: error,
    createProductTypeCarouselLoading: isLoading,
    createProductTypeCarouselMutate: mutate,
  };
};
